/**
 * 1등급 이용약관 — 학부모용 / 학원용 분기
 * 라우트: /app/terms/:role  (role = 'parent' | 'academy')
 */
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { IoChevronBack } from 'react-icons/io5';

const COMPANY = '주식회사 홍컴즈';
const SERVICE = '1등급';
const CONTACT = 'kkan2222@gmail.com';
const EFFECTIVE = '2026년 5월 23일';

const PARENT_TERMS = [
  {
    h: '제1조 (목적)',
    p: [
      `본 약관은 ${COMPANY}(이하 "회사")가 제공하는 학원-학부모 연결 서비스 "${SERVICE}"(이하 "서비스")의 이용과 관련하여 회사와 학부모 회원(이하 "회원") 사이의 권리·의무 및 책임사항을 정함을 목적으로 합니다.`,
    ],
  },
  {
    h: '제2조 (용어의 정의)',
    p: [
      '1. "서비스"란 학부모가 자녀를 등록할 학원을 검색·문의·신청하고, 등록된 학원의 알림장·일정·결제 내역 등을 확인할 수 있도록 회사가 제공하는 일체의 온라인 서비스를 의미합니다.',
      '2. "회원"이란 본 약관에 동의하고 회사와 이용계약을 체결한 자로서, 본 약관에서는 자녀의 학원 생활을 관리·확인하려는 학부모(또는 보호자)를 의미합니다.',
      '3. "학원"이란 서비스에 가입하여 회원에게 정보·교육 콘텐츠를 제공하는 학원 운영자를 의미하며, 회원과는 별개의 계약 당사자입니다.',
      '4. "자녀 정보"란 회원이 등록한 자녀의 이름·생년·사진 등 식별 정보를 의미합니다.',
    ],
  },
  {
    h: '제3조 (약관의 효력 및 변경)',
    p: [
      '1. 본 약관은 회원이 서비스에 가입할 때 동의함으로써 효력이 발생합니다.',
      '2. 회사는 관련 법령을 위배하지 않는 범위에서 약관을 개정할 수 있으며, 변경된 약관은 서비스 화면을 통해 시행 7일 전부터 공지합니다. 회원에게 불리한 변경은 시행 30일 전부터 공지합니다.',
      '3. 회원이 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 탈퇴할 수 있습니다.',
    ],
  },
  {
    h: '제4조 (회원가입)',
    p: [
      '1. 가입은 학부모가 본 약관과 개인정보 처리방침에 동의하고, 휴대전화번호 인증 또는 소셜 로그인(카카오·구글 등) 절차를 완료한 시점에 성립합니다.',
      '2. 회사는 다음 각 호에 해당하는 경우 가입을 거절하거나 사후에 회원자격을 박탈할 수 있습니다.',
      '가. 타인의 명의·연락처를 도용한 경우',
      '나. 허위 정보를 기재한 경우',
      '다. 만 14세 미만이 법정대리인 동의 없이 가입한 경우',
    ],
  },
  {
    h: '제5조 (회원의 자녀 등록과 책임)',
    p: [
      '1. 회원은 본인의 자녀에 한하여 자녀 정보를 등록할 수 있으며, 자녀 또는 다른 보호자의 권리를 침해하지 않을 책임을 집니다.',
      '2. 회원이 등록한 자녀 정보는 회원이 직접 학원에 수강 신청·문의를 한 경우에 한해 해당 학원에 제공됩니다.',
      '3. 회원은 등록한 자녀 정보를 언제든지 수정·삭제할 수 있으며, 부정확한 정보로 인해 발생하는 불이익에 대한 책임은 회원에게 있습니다.',
    ],
  },
  {
    h: '제6조 (서비스의 내용)',
    p: [
      '회사는 회원에게 다음과 같은 서비스를 제공합니다.',
      '1. 학원 검색·지도·상세 정보 열람',
      '2. 자녀 등록 및 학원 수강 신청·문의',
      '3. 학원이 발송하는 알림장·공지·사진 수신',
      '4. 출결, 일정, 시험 성적, 결제 내역 등 자녀의 학원 생활 정보 확인',
      '5. 학원과의 1:1 채팅',
      '6. 기타 회사가 정하는 부가 서비스',
    ],
  },
  {
    h: '제7조 (학원과의 계약 관계)',
    p: [
      '1. 회원과 학원 사이의 수강 계약·수강료 결제·환불 등은 회원과 학원 당사자 간의 계약이며, 회사는 거래의 당사자가 아닙니다.',
      '2. 회사는 학원이 제공하는 정보(시설·강사·수강료 등)의 정확성을 보증하지 않으며, 학원과 회원 사이에 분쟁이 발생한 경우 중립적인 입장에서 자료 제공 등 합리적 범위 내에서 협조합니다.',
    ],
  },
  {
    h: '제8조 (회원의 의무)',
    p: [
      '1. 회원은 다음 각 호의 행위를 하여서는 안 됩니다.',
      '가. 타인의 정보를 도용하거나 허위 사실을 기재하는 행위',
      '나. 학원·다른 회원·제3자를 비방하거나 명예를 훼손하는 행위',
      '다. 서비스를 이용한 영업·광고·홍보 등 영리 목적의 행위',
      '라. 회사 또는 제3자의 저작권 등 지적재산권을 침해하는 행위',
      '마. 정상적인 서비스 운영을 방해하는 행위',
      '2. 회원의 계정 및 비밀번호 관리 책임은 회원에게 있으며, 부주의로 인한 손해에 대해 회사는 책임을 지지 않습니다.',
    ],
  },
  {
    h: '제9조 (서비스 이용의 제한 및 중지)',
    p: [
      '1. 회사는 다음 각 호에 해당하는 경우 서비스 이용을 제한·중지할 수 있습니다.',
      '가. 회원이 본 약관의 의무를 위반한 경우',
      '나. 서비스 설비의 보수·점검·교체 등으로 인한 부득이한 경우',
      '다. 천재지변, 정전, 통신두절 등 불가항력적 사유가 있는 경우',
      '2. 회사는 제1항의 사유로 서비스 제공이 중단되는 경우 사전에 공지합니다. 다만, 사전 공지가 곤란한 경우 사후에 공지할 수 있습니다.',
    ],
  },
  {
    h: '제10조 (계약 해지 및 탈퇴)',
    p: [
      '1. 회원은 언제든지 서비스 내 "서비스 탈퇴하기" 메뉴를 통해 이용계약을 해지할 수 있습니다.',
      '2. 탈퇴 시 회원의 계정·자녀 정보·프로필 등은 지체 없이 파기됩니다. 다만, 관련 법령에 따라 일정 기간 보관해야 하는 정보는 해당 기간 동안 보관 후 파기됩니다.',
      '3. 탈퇴 이전에 학원과 주고받은 메시지·결제 내역 등 거래 기록은 학원의 권리 보호를 위해 별도 보관될 수 있습니다.',
    ],
  },
  {
    h: '제11조 (면책 조항)',
    p: [
      '1. 회사는 천재지변, 불가항력, 회원의 귀책사유로 인한 서비스 이용 장애에 대하여 책임을 지지 않습니다.',
      '2. 회사는 회원과 학원 사이에 발생한 거래·서비스에 대한 분쟁에 개입하지 않으며, 그로 인한 손해에 대해 책임을 지지 않습니다.',
      '3. 회사는 회원이 게시한 정보·자료의 신뢰성, 정확성에 대해 보증하지 않습니다.',
    ],
  },
  {
    h: '제12조 (분쟁 해결)',
    p: [
      '1. 본 약관과 관련하여 분쟁이 발생한 경우 회사와 회원은 상호 신의·성실에 따라 협의로 해결하도록 노력합니다.',
      '2. 협의가 이루어지지 않은 경우, 관할 법원은 민사소송법에 따른 회사 본점 소재지 관할 법원으로 합니다.',
    ],
  },
];

const ACADEMY_TERMS = [
  {
    h: '제1조 (목적)',
    p: [
      `본 약관은 ${COMPANY}(이하 "회사")가 운영하는 학원-학부모 연결 플랫폼 "${SERVICE}"(이하 "서비스")의 학원 운영자 회원(이하 "학원 회원")과 회사 사이의 권리·의무 및 책임사항을 정함을 목적으로 합니다.`,
    ],
  },
  {
    h: '제2조 (용어의 정의)',
    p: [
      '1. "학원 회원"이란 본 약관에 동의하고 서비스에 학원을 등록·운영하는 자(학원 운영자·원장·관리자 등 권한을 부여받은 자 포함)를 의미합니다.',
      '2. "학원 정보"란 학원명, 주소, 연락처, 대표자명, 사업자등록번호, 강사·수강료·시설 사진 등 학원 회원이 등록·관리하는 정보 일체를 의미합니다.',
      '3. "수강생/학부모 회원"이란 학원 회원이 운영하는 학원에 자녀를 등록·문의하는 학부모 회원과 그 자녀를 의미합니다.',
    ],
  },
  {
    h: '제3조 (약관의 효력 및 변경)',
    p: [
      '1. 본 약관은 학원 회원이 서비스에 학원을 등록·이용하면서 동의함으로써 효력이 발생합니다.',
      '2. 회사는 관련 법령을 위배하지 않는 범위에서 약관을 개정할 수 있으며, 변경된 약관은 시행 7일 전부터 서비스 내 공지합니다. 학원 회원에게 불리한 변경은 시행 30일 전부터 공지합니다.',
    ],
  },
  {
    h: '제4조 (가입과 학원 등록 심사)',
    p: [
      '1. 학원 회원은 본 약관과 개인정보 처리방침에 동의하고, 본인 인증 및 학원 정보(학원명·대표자명·연락처 등) 입력을 완료해야 합니다.',
      '2. 회사는 학원의 실재 여부 확인을 위해 사업자등록증·강사 자격 증빙 등 추가 자료를 요청할 수 있으며, 다음의 경우 등록을 거절·취소할 수 있습니다.',
      '가. 허위 정보를 기재하거나 타인의 명의를 도용한 경우',
      '나. 「학원의 설립·운영 및 과외교습에 관한 법률」 등 관계 법령상 등록·신고 요건을 충족하지 않는 경우',
      '다. 회원·자녀의 안전이나 권익을 침해할 우려가 명백한 경우',
      '3. 등록 심사 결과에 대한 통지는 서비스 내 알림 또는 등록한 연락 수단을 통해 이루어집니다.',
    ],
  },
  {
    h: '제5조 (서비스의 내용)',
    p: [
      '회사는 학원 회원에게 다음과 같은 서비스를 제공합니다.',
      '1. 학원 정보 등록·공개 및 학부모 회원 대상 검색 노출',
      '2. 수강생·반·일정·출결·시험 성적 관리',
      '3. 학부모와의 1:1 채팅 및 알림장·공지 발송',
      '4. 결제·정산 연동(별도 안내에 따른 부가 서비스)',
      '5. 기타 회사가 정하는 부가 서비스',
    ],
  },
  {
    h: '제6조 (학원 정보의 등록·관리)',
    p: [
      '1. 학원 회원은 학원 정보를 항상 정확하고 최신 상태로 유지할 의무가 있으며, 허위 또는 과장된 정보를 게시하여서는 안 됩니다.',
      '2. 학원 정보·사진·홍보 자료의 저작권 등 권리관계는 학원 회원의 책임이며, 제3자의 권리를 침해하지 않을 것을 보장합니다.',
      '3. 학원 회원이 등록·발송한 게시물(공지·알림장·채팅 메시지 등)로 인해 분쟁이 발생할 경우, 회사는 게시물의 임시 차단·삭제 등 조치를 취할 수 있습니다.',
    ],
  },
  {
    h: '제7조 (학부모 회원·자녀 정보의 취급)',
    p: [
      '1. 학원 회원은 학부모·자녀 정보를 수강 관리 등 학원 운영 목적 외로 이용해서는 안 됩니다.',
      '2. 학원 회원은 개인정보 보호 관련 법령을 준수해야 하며, 자체적인 개인정보 보호 책임을 부담합니다.',
      '3. 회사가 제공한 자료·정보를 제3자에게 누설·제공·판매하는 행위는 일체 금지됩니다.',
    ],
  },
  {
    h: '제8조 (수강료 등 거래의 당사자)',
    p: [
      '1. 학원과 학부모 회원 사이의 수강 계약·수강료 결제·환불 등은 양 당사자 사이의 거래이며, 회사는 거래 당사자가 아닙니다.',
      '2. 학원 회원은 「학원의 설립·운영 및 과외교습에 관한 법률」 등 관계 법령에 따라 학부모에게 수강료·환불 기준을 명확히 안내하고 이를 준수해야 합니다.',
      '3. 결제·정산 연동 서비스를 이용하는 경우, 별도의 부가 약관 및 이용 수수료가 적용될 수 있습니다.',
    ],
  },
  {
    h: '제9조 (학원 회원의 의무)',
    p: [
      '1. 학원 회원은 다음 각 호의 행위를 하여서는 안 됩니다.',
      '가. 허위 학원 정보 등록, 타 학원·강사 비방·허위 후기 작성',
      '나. 회원·자녀를 상대로 한 부당한 영업 또는 강압적 권유',
      '다. 회사의 사전 동의 없이 서비스를 이용한 광고·홍보·재판매',
      '라. 회사 또는 제3자의 지적재산권을 침해하는 행위',
      '마. 정상적인 서비스 운영을 방해하거나 시스템에 무단 접근하는 행위',
    ],
  },
  {
    h: '제10조 (서비스 이용의 제한 및 중지)',
    p: [
      '1. 회사는 다음 각 호에 해당하는 경우 학원 노출 제한, 서비스 이용 정지, 계정 해지 등의 조치를 취할 수 있습니다.',
      '가. 본 약관을 위반한 경우',
      '나. 학부모 회원의 신고가 누적되어 학부모 또는 자녀의 권익을 침해할 우려가 명백한 경우',
      '다. 관련 법령을 위반하거나 행정기관의 조치가 있는 경우',
      '2. 회사는 제1항의 조치를 취하기 전 학원 회원에게 사유를 통지하고 소명 기회를 제공합니다. 다만, 긴급한 사유가 있는 경우 사후에 통지할 수 있습니다.',
    ],
  },
  {
    h: '제11조 (계약 해지 및 탈퇴)',
    p: [
      '1. 학원 회원은 언제든지 서비스 내 메뉴를 통해 이용계약을 해지할 수 있습니다. 다만, 재학 중인 수강생이 있는 경우 학부모 회원에게 안내 후 자료 이관 등 후속 조치를 취해야 합니다.',
      '2. 탈퇴 시 학원 정보·게시물은 지체 없이 비공개 처리·파기됩니다. 다만, 회원·학부모와의 거래 기록은 분쟁 대비를 위해 관계 법령상 보관 기간 동안 보관됩니다.',
    ],
  },
  {
    h: '제12조 (면책 조항)',
    p: [
      '1. 회사는 천재지변, 불가항력, 학원 회원·학부모 회원의 귀책사유로 인한 서비스 이용 장애에 대하여 책임을 지지 않습니다.',
      '2. 회사는 학원과 학부모 회원 사이의 거래·서비스 품질·환불 등에 대해 책임을 지지 않으며, 학원 회원이 등록한 정보의 진실성·정확성을 보증하지 않습니다.',
    ],
  },
  {
    h: '제13조 (분쟁 해결)',
    p: [
      '1. 본 약관에 관한 분쟁은 회사와 학원 회원 간 상호 협의로 해결합니다.',
      '2. 협의가 이루어지지 않을 경우 관할 법원은 민사소송법에 따른 회사 본점 소재지 관할 법원으로 합니다.',
    ],
  },
];

const AppTermsPage = () => {
  const navigate = useNavigate();
  const { role } = useParams();
  const isAcademy = role === 'academy';
  const sections = isAcademy ? ACADEMY_TERMS : PARENT_TERMS;
  const title = isAcademy ? '이용약관 (학원용)' : '이용약관 (학부모용)';

  return (
    <Container>
      <Header>
        <BackBtn onClick={() => navigate(-1)} aria-label="뒤로 가기">
          <IoChevronBack size={24} />
        </BackBtn>
        <Title>{title}</Title>
      </Header>

      <Content>
        <Lead>
          {SERVICE} 서비스를 이용해 주셔서 감사합니다.
          본 약관은 {isAcademy ? '학원 회원' : '학부모 회원'}에게 적용됩니다.
        </Lead>

        {sections.map((s) => (
          <Section key={s.h}>
            <H2>{s.h}</H2>
            {s.p.map((line, i) => <P key={i}>{line}</P>)}
          </Section>
        ))}

        <Footer>
          <FooterText>운영사: {COMPANY}</FooterText>
          <FooterText>문의: {CONTACT}</FooterText>
          <FooterText>시행일: {EFFECTIVE}</FooterText>
        </Footer>
      </Content>
    </Container>
  );
};

export default AppTermsPage;

const Container = styled.div`
  background: #fff;
  min-height: 100vh;
  padding-bottom: 80px;
`;

const Header = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border-bottom: 1px solid #E5E7EB;
`;

const BackBtn = styled.button`
  color: #111;
  background: transparent;
`;

const Title = styled.p`
  font-size: 17px;
  font-weight: 700;
  color: #111827;
`;

const Content = styled.div`
  max-width: 480px;
  margin: 0 auto;
  padding: 20px 18px;
`;

const Lead = styled.p`
  font-size: 14px;
  line-height: 1.7;
  color: #374151;
  background: #F4F7FF;
  padding: 14px 16px;
  border-radius: 12px;
  margin-bottom: 24px;
`;

const Section = styled.div`
  margin-bottom: 26px;
`;

const H2 = styled.h2`
  font-size: 15.5px;
  font-weight: 800;
  color: #111827;
  margin-bottom: 10px;
`;

const P = styled.p`
  font-size: 13.5px;
  color: #374151;
  line-height: 1.85;
  word-break: keep-all;
  margin-bottom: 4px;
`;

const Footer = styled.div`
  margin-top: 32px;
  padding-top: 16px;
  border-top: 1px solid #E5E7EB;
`;

const FooterText = styled.p`
  font-size: 12.5px;
  color: #6B7280;
  line-height: 1.7;
`;
